import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { NotAuthorizedReason } from '../models';
import { UserStore } from '../ngrx';

export const adminGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const userStore = inject(UserStore);

  const isAdmin = userStore.isAdmin();
  if (isAdmin) {
    return true;
  } else {
    return router.createUrlTree(['not-authorized'], {
      queryParams: { reason: NotAuthorizedReason.NOT_ADMIN },
    });
  }
};
